import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Kill switch for the computer-use readiness checks in Rust: the run-start
 * refusal and the input check. ON turns them off, so a check that misfires on
 * some macOS version can be undone without a desktop release.
 */
export const CUA_READINESS_GATE_KILL_FLAG_KEY = 'op-agents-disable-cua-readiness-gate';

export const useIsCuaReadinessGateKilled = (): boolean =>
  useBooleanFlagValue(CUA_READINESS_GATE_KILL_FLAG_KEY, false);
